<template>
  <v-container>
    <GuideTour config-key="settings.phonePermission" clearAllSubtitle/>

    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <div>
      <div class="mb-6 d-flex justify-end" style="gap: 8px;">
        <v-btn v-if="!isEdit" color="primary" class="px-8" @click="isEdit = true;">
          <v-icon small>mdi-pencil</v-icon>
          編輯
        </v-btn>
        <template v-else>
            <v-btn color="grey-5" dark class="px-4 px-md-8" @click="cancel">取消修改</v-btn>
            <v-btn color="red-6" dark class="px-4 px-md-8" @click="save">確認修改</v-btn>
        </template>
      </div>

      <SettingCard
        v-if="changeSettings.length"
        :settings-data.sync="changeSettings"
        :settings-meta="settingsMeta"
        :is-edit="isEdit"
        :convert-func="convertSettingData"
        :restore-func="restoreSettingData"
      />
    </div>
  </v-container>
</template>

<script>
import GuideTour from "@/components/utils/GuideTour.vue";
import SettingCard from "@/components/message/setting/SettingCard.vue";
import { getPhonePermissionSettingsAPI, updateMessageSettingsAPI, updatePhonePermissionSettingsAPI } from "@/api";
import { mapGetters } from "vuex";
import { convertSettingData, restoreSettingData } from "@/utils/messageSetting";

export default {
  name: 'PhonePermissionSettings',

  components: {SettingCard, GuideTour},

  data() {
    return {
      loading: false,
      settings: [],
      changeSettings: [],
      isEdit: false,
    }
  },

  computed: {
    ...mapGetters([
      'axiosParamData',
    ]),
    settingsMeta() {
      return [
        {
          "key": "phoneVisible",
          "type": "switch",
          "title": "授權患者手機給醫師"
        }
      ]
    }
  },

  mounted() {
    this.getPhonePermissionSettings()
  },

  methods: {
    getPhonePermissionSettings() {
      this.loading = true
      getPhonePermissionSettingsAPI(this.axiosParamData).then(res => {
        this.settings = res.data.data
        this.changeSettings = res.data.data
        this.loading = false
      })
    },
    convertSettingData(data) {
      const settingsData = []
      data.forEach(setting => {
        settingsData.push({
          id: setting.doctor_in_clinic_id,
          code: setting.doctor_code,
          name: setting.doctor_name,
          phoneVisible: Boolean(Number(setting.phone_visible))
        })
      })
      return settingsData
    },
    restoreSettingData(newData) {
      const originalData = [];
      newData.forEach(setting => {
        const originalSetting = {
          doctor_code: setting.code,
          doctor_name: setting.name,
          doctor_in_clinic_id: setting.id,
          phone_visible: setting.phoneVisible ? "1" : "0"
        };

        originalData.push(originalSetting);
      });

      return originalData;
    },
    cancel() {
      this.changeSettings = JSON.parse(JSON.stringify(this.settings))
      this.isEdit = false
    },
    save() {
      this.loading = true
      const data = {
        ...this.axiosParamData,
        data: this.changeSettings
      }
      updatePhonePermissionSettingsAPI(data).then(() => {
        this.isEdit = false
        this.getPhonePermissionSettings()
        // this.loading = false
      }).catch(e => {
        console.error(e)
        this.loading = false
      })

    },
  }
};
</script>

<style scoped>
/* Your styles here */
</style>
